import { Routes } from '@angular/router';
import { FinalScoresComponent } from './features/final-scores/final-scores.component';
import { LeaderboardComponent } from './features/leaderboard/leaderboard.component';
import { QuestionComponent } from './features/question/question.component';
import { RulesComponent } from './features/rules/rules.component';
import { SelectLanguageComponent } from './features/select-language/select-language.component';
import { MainMenuComponent } from './features/main-menu/main-menu.component';
import { SelectTopicComponent } from './features/select-topic/select-topic.component';
import { SettingsComponent } from './features/settings/settings.component';
import { UserDetailsComponent } from './features/user-details/user-details.component';
import { WelcomeComponent } from './features/welcome/welcome.component';
import { ProfilesComponent } from './features/profiles/profiles.component';
import { MultiplayerComponent } from './features/multiplayer/multiplayer.component';
import { CreateRoomComponent } from './features/multiplayer/create-room/create-room.component';
import { WaitingLobbyComponent } from './features/multiplayer/waiting-lobby/waiting-lobby.component';
import { RoomsComponent } from './features/multiplayer/rooms/rooms.component';
import { JoinRoomComponent } from './features/multiplayer/join-room/join-room.component';
import { MainMenuEvComponent } from './features/main-menu-ev/main-menu-ev.component';
import { CreditsComponent } from './features/credits/credits.component';

/* routes definition */
export const appRoutes: Routes = [
    {
        path: '',
        component: WelcomeComponent,
        data: {animation: {pageAlias: 'welcome'}}
      },
      {
        path: 'select-language',
        component: SelectLanguageComponent,
        data: {animation: {pageAlias: 'select-language'}},
        // canActivate: [UserSessionActiveGuard]
      },
      {
        path: 'main-menu',
        component: MainMenuComponent,
        data: {animation: {pageAlias: 'main-menu'}}
      },
      {
        path: 'main-menu-ev',
        component: MainMenuEvComponent,
        data: {animation: {pageAlias: 'main-menu-ev'}}
      },
      {
        path: 'rules',
        component: RulesComponent,
        data: {animation: {pageAlias: 'rules'}}
      },
      {
        path: 'credits',
        component: CreditsComponent,
        data: {animation: {pageAlias: 'credits'}}
      },
      {
        path: 'select-topic',
        component: SelectTopicComponent,
        data: {animation: {pageAlias: 'select-topic'}}
      },
      {
        path: 'question',
        component: QuestionComponent,
        data: {animation: {pageAlias: 'question'}}
      },
      {
        path: 'final-scores',
        component: FinalScoresComponent,
        data: {animation: {pageAlias: 'final-scores'}}
      },
      {
        path: 'settings',
        component: SettingsComponent,
        data: {animation: {pageAlias: 'settings'}}
      },
      {
        path: 'leaderboard',
        component: LeaderboardComponent,
        data: {animation: {pageAlias: 'leaderboard'}}
      },
      {
        path: 'user-details',
        component: UserDetailsComponent,
        data: {animation: {pageAlias: 'user-details'}}
      },
      {
        path: 'profiles',
        component: ProfilesComponent,
        data: {animation: {pageAlias: 'profiles'}}
      },
      {
        path: 'multiplayer',
        component: MultiplayerComponent,
        data: {animation: {pageAlias: 'multiplayer'}},
        children: [
          {
            path: '',
            redirectTo: 'rooms',
            pathMatch: 'full'
          },
          {
            path: 'rooms',
            component: RoomsComponent,
          },
          {
            path: 'create-room',
            component: CreateRoomComponent,
          },
          {
            path: 'lobby/:id',
            component: WaitingLobbyComponent,
          },
          {
            path: 'join-private/:id',
            component: JoinRoomComponent,
          },
        ],
      }
];
